import { type OrganizationDataSourceAccount } from '@libraries/typescript/api_client';

export type HHAExchangeCaregiverFieldVisibility = {
    readonly showCaregiverStatus: boolean;
    readonly showCompliance: boolean;
};

/**
 * Visibility for the HHAeXchange caregiver status and compliance fields.
 *
 * Each field is shown only when the account setting that actually populates
 * it is enabled, so an organization that has not opted in never sees an
 * all-dash column: status data comes from the extended-roster sync
 * (`include_non_terminated_caregivers_as_active`) and compliance data from
 * the compliance document sync (`caregiver_compliance_sync_enabled`).
 */
export function getHHAExchangeCaregiverFieldVisibility(
    dataSourceAccounts: Array<OrganizationDataSourceAccount> | undefined,
): HHAExchangeCaregiverFieldVisibility {
    const account = dataSourceAccounts?.find(
        (candidate) => candidate.type === 'hhaexchange',
    );
    const settings = account?.source_account_settings;
    if (settings?.type !== 'hhaexchange') {
        return { showCaregiverStatus: false, showCompliance: false };
    }
    return {
        showCaregiverStatus:
            settings.include_non_terminated_caregivers_as_active === true,
        showCompliance: settings.caregiver_compliance_sync_enabled === true,
    };
}
